<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import CustomersTableHeader from "./customers/CustomersTableHeader.vue";
import CustomerTableRow from "./customers/CustomerTableRow.vue";
import CustomersSearch from "./customers/CustomersSearch.vue";

const store = useStore();

const customers = computed(() => store.getters["customers/customers"]);
const loading = computed(() => store.getters["customers/loading"]);
const filters = computed(() => store.getters["customers/filters"])

onMounted(() => {
  store.dispatch('customers/fetchCustomers');
})


</script>

<template>
  <div class="tailwind">
    <div class="tw-flex tw-flex-col tw-mb-12">
      <h1 class="tw-text-4.5xl tw-text-font-primary tw-font-bold tw-font-sans">
        Customers
      </h1>
      <p class="tw-text-font-secondary tw-text-base">
        Customers that belong to your merchant account.
      </p>
    </div>

    <div class="tw-bg-white tw-rounded-lg tw-p-8 tw-flex tw-flex-col tw-space-y-8 tw-flex-1 tw-overflow-hidden">
      <CustomersSearch />

      <CustomersTableHeader />

      <div
        v-if="loading"
        class="tw-flex tw-flex-col tw-items-center tw-space-y-10 tw-justify-center tw-my-24 tw-w-full tw-max-w-sm tw-mx-auto"
      >
        <svg-vue
          icon="icons/loading"
          class="tw-w-1/2 tw-h-auto tw-text-blue/20"
        />
        <p class="tw-text-2xl tw-text-center">
          Loading
        </p>
      </div>

      <div
        v-if="customers.length > 0"
        class="tw-overflow-y-auto tw-h-[75vh]"
      >
        <div
          class="tw-rounded-xl tw-border tw-border-grey-light tw-text-grey-dark"
        >
          <CustomerTableRow
            v-for="(customer, index) in customers"
            :key="index"
            :index="index"
            :customer="customer"
            :total-customers="customers.length"
          />
        </div>
      </div>

      <div
        v-else
        class="tw-flex tw-flex-col tw-items-center tw-space-y-10 tw-justify-center tw-my-24 tw-w-full tw-max-w-sm tw-mx-auto tw-h-[30vh]"
      >
        <svg-vue
          icon="illustrations/landscape-blue"
          class="tw-w-56"
        />

        <p class="tw-text-2xl tw-text-center tw-whitespace-nowrap">
          {{ filters?.search ? "You don't have any customers that match that search." : "Looks like you don't have any customers." }}
        </p>
      </div>
    </div>
  </div>
</template>